import Masthead from "./components/Masthead";
import HeroCovers from "./components/HeroCovers";
import TopRanking from "./components/TopRanking";
import TopicWall from "./components/TopicWall";
import HeadlineGrid from "./components/HeadlineGrid";
import MostDiscussed from "./components/MostDiscussed";
import SubscribeBand from "./components/SubscribeBand";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Masthead />
      <main className="w-full">
        <div className="animate-fade-up">
          <HeroCovers />
        </div>
        <div className="animate-fade-up" style={{ animationDelay: "0.1s" }}>
          <TopRanking />
        </div>
        <div className="animate-fade-up" style={{ animationDelay: "0.15s" }}>
          <TopicWall />
        </div>
        <div className="animate-fade-up" style={{ animationDelay: "0.2s" }}>
          <HeadlineGrid />
        </div>
        <div className="animate-fade-up" style={{ animationDelay: "0.25s" }}>
          <MostDiscussed />
        </div>
        <SubscribeBand />
      </main>
      <SiteFooter />
    </div>
  );
}